import vClickOutside from 'click-outside-vue3'
export default {
  install: (app) => {
    app.directive('click-outside', vClickOutside.directive)
  }
}
